import React, { useState, useEffect, ChangeEvent } from "react";
import * as yup from "yup";
import { Card, Table } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { ToastContainer, toast } from "react-toastify";
import useAxiosPost from "../../../hooks/useAxiosPost";
import { notifyError } from "../../toast/Error";
import { notifySuccess } from "../../toast/Success";
import "./../../../assets/styles/olt.css";
import "./../../../assets/styles/ont-list.css";
import { formatDate } from "../../../helpers/date";
type Props = {
  isLoggedIn?: boolean;
};

const AllOLTModelsComponent: React.FC<Props> = ({}) => {
  const [
    getSuperCOOData,
    getSuperCOOResponse,
    COOError,
    COOLoading,
    COOMessage,
    COOErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/getAllOltModels");
  const [superCOOs, setSuperCOOs] = useState<any>([]);
  useEffect(() => {
    getSuperCOOData({});
  }, []);

  useEffect(() => {
    if (COOError !== null && COOErrorCount !== 0) {
      notifyError(COOError);
    }
  }, [COOError, COOErrorCount]);
  useEffect(() => {
    if (getSuperCOOResponse !== null) {
      console.log({ getSuperCOOResponse });
      setSuperCOOs(getSuperCOOResponse.responseData || []);
    }
  }, [getSuperCOOResponse]);

  return (
    <>
      <ToastContainer />
      <Row className="justify-content-center">
        <Col xs lg="12" md="12" xl="12" className="p-5">
          <Card className="p-5">
            <Card.Title className="text-center olt-heading fw-700 pt-3 ">
              {" "}
              All OLT Models Page
            </Card.Title>
            <Row className="mt-5">
              <Col md={12} lg={12} xs={12} sm={12} xl={8} xxl={12}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th className="table-header-standard">Brand</th>
                      <th className="table-header-standard">Model Name</th>
                      <th className="table-header-standard">Technology</th>
                      <th className="table-header-standard">Total Slots</th>
                      <th className="table-header-standard">GPon Slots</th>
                      <th className="table-header-standard">GPon Port</th>
                      <th className="table-header-standard">Epon Ports</th>
                      <th className="table-header-standard">
                        isOltGponEnabled
                      </th>
                      <th className="table-header-standard">
                        isOltEponEnabled
                      </th>
                      <th className="table-header-standard">Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {superCOOs.map((item: any) => {
                      return (
                        <tr key={item.intPkOLTModelID}>
                          <td>{item.brandName}</td>
                          <td>{item.oltModelName}</td>
                          <td>{item.technology}</td>
                          <td>{item.totalSlots}</td>
                          <td>{item.gponSlots}</td>
                          <td>{item.gponPorts}</td>
                          <td>{item.eponPorts}</td>
                          <td>{item.isOltGponEnabled == 1 ? "Yes" : "No"}</td>
                          <td>{item.isOltEponEnabled == 1 ? "Yes" : "No"}</td>
                          <td>
                            <img src={item.url} style={{ maxWidth: "150px" }} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default AllOLTModelsComponent;
